import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Data2Service } from '../../common/data2.service';

@Component({
	selector: 'app-offers-show',
	templateUrl: './offers-show.component.html',
	styleUrls: ['./offers-show.component.css'],
})
export class OffersShowComponent implements OnInit {
	pageTitle = 'Oferta...';
	loader = false;
	private readonly itemsBeforeDataLoad = 3;
	offer = {
		id: this.route.snapshot.params['id'],
		code: null,
		name: null,
		queryRoom: null,
		queryPriceList: null,
		owner: null,
		costsFixed: null,
		costsFixedCurrency: null,
		costsVariable: null,
		costsVariableCurrency: null,
		programFees: null,
		programFeesCurrency: null,
		plannedPayments: null,
		plannedPaymentsCurrency: null,
		status: null,
		confirmedPeople: null,
		confirmedReservations: null,
		optionalPeople: null,
		optionalReservations: null,
		canceledPeople: null,
		canceledReservations: null,
		priceNow: null,
		priceAvg: null,
		income: null,
		costs: null,
		profit: null,
	};
	terms: Array<any> = [];
	termsQuantity: number = null;
	termsAvaliableQuantity: number = null;
	averagePrice: number = null;

	constructor(
		private readonly api: Data2Service,
		private readonly route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		this.loader = true;
		this.api.get('/istourOffersTerms?offer=' + this.offer.id, (result, error) => {
			this.terms = result.data;
			this.termsQuantity = this.terms.length;
			this.termsAvaliableQuantity = this.terms.filter((obj) => obj.available == 1).length;
		});
		this.api.get('/istourOffers/' + this.offer.id, (result, error) => {
			this.offer = result.data;
			this.pageTitle = 'Oferta: ' + this.offer.name;
			this.loader = false;
		});
	}
}
